/** ----------------------------------------
     Element Values
 ---------------------------------------- */

const container = document.body.querySelector('.screen__main');
const retainer = document.body.querySelector('.screen__retainer');
const active = document.body.querySelector('.screen__active');

/** ----------------------------------------
    Show once ready
 ---------------------------------------- */

const initFadeIn = () => {
    document.getElementsByTagName("body")[0].style.opacity = 1; 
}

/** ----------------------------------------
    Random theme
 ---------------------------------------- */

 const randomTheme = () => {
    const randInt = Math.round(Math.random()); // between 0 and 1;
    const themes = ["red-theme", "blue-theme"];
    document.body.classList.add(themes[randInt]);
}

/** ----------------------------------------
    Select Element
 ---------------------------------------- */

const select = {
    'container': container,
    'retainer': retainer,
    'active': active,
};

/** ----------------------------------------
     Slide Index
 ---------------------------------------- */

const index = number => number - 1;

/** ----------------------------------------
     Apply Slide
 ---------------------------------------- */

const insert = (html, type = 'container') => {
    select[type].insertAdjacentHTML('beforeend', html);
};

/** ----------------------------------------
     Copy Container
 ---------------------------------------- */

const copy = (original = 'retainer', duplicate = 'active') => {
    select[duplicate].innerHTML = select[original].innerHTML;
};

/** ----------------------------------------
     Empty Container
 ---------------------------------------- */

const empty = (type = 'container') => select[type].innerHTML = '';

/** ----------------------------------------
     Image Loaded
 ---------------------------------------- */

const imageLoaded = url => {
    return new Promise((resolve, reject) => {
        let img = new Image();
        img.addEventListener('load', e => resolve(img));
        img.addEventListener('error', () => {
            reject(new Error(`Failed to load image's URL: ${url}`));
        });
        img.src = url;
    });
};

/** ----------------------------------------
     Schedule
 ---------------------------------------- */

const schedule = (duration, callback) => {
    setTimeout(callback, duration);
};
/** ----------------------------------------
    Export Modules
 ---------------------------------------- */

module.exports = {
    initFadeIn,
    randomTheme,
    copy,
    empty,
    index,
    imageLoaded,
    insert,
    schedule
};
